export default "__VITE_ASSET__DxwY8tUc__"